'use client'

import IconFullscreen from '@icon/house/map-fullscreen.svg'
import IconMinimized from '@icon/house/map-minimized.svg'
import { global } from '@store/index'
import { exitFullscreen, isFullscreen, requestFullscreen } from '@utils'
import { useEffect } from 'react'
import { useRecoilValue } from 'recoil'
import { useMapboxContext } from '../../map/context'
import useControl from '../useControl'

export default function FullscreenControl() {
  return useControl(<FullscreenControlContent />, { position: 'top-right', groupClass: false })
}
function FullscreenControlContent() {
  const { fullScreen, toggleFullScreen, map, mapContainer, mapLoaded } = useMapboxContext()
  const { mobile } = useRecoilValue(global)

  useEffect(() => {
    if (!mapLoaded) return

    const scrollZoomEnabled = map.scrollZoom.isEnabled()
    const isDragPanEnabled = map.dragPan.isEnabled()

    // 如果全屏，打开鼠标滚动功能
    function handleScrollZoom() {
      if (!scrollZoomEnabled) {
        if (document.fullscreenElement) {
          map.scrollZoom.enable()
        } else {
          map.scrollZoom.disable()
        }
      }

      if (!isDragPanEnabled) {
        if (document.fullscreenElement) {
          map.dragPan.enable()
        } else {
          map.dragPan.disable()
        }
      }

      if (isFullscreen()) {
        toggleFullScreen(true)
      } else {
        toggleFullScreen(false)
        setTimeout(() => {
          map.resize()
        }, 50)
      }
    }
    map.on('resize', handleScrollZoom)

    return () => {
      map.off('resize', handleScrollZoom)
    }
  }, [mapLoaded, mapContainer, map, toggleFullScreen])

  function toggleHandle() {
    if (fullScreen) {
      exitFullscreen()
    } else {
      requestFullscreen(mapContainer)
    }
  }

  if (mobile) {
    return null
  }

  return (
    <div className='w-40 h-40 rounded-sm cursor-pointer relative bg-white grid place-items-center shadow-md hover:bg-neutral-2' onClick={toggleHandle}>
      {
        fullScreen
          ? <IconMinimized className='w-20 h-20' />
          : <IconFullscreen className='w-20 h-20' />
      }
    </div>
  )
}
